import { render, staticRenderFns } from "./NostoNotFound.vue?vue&type=template&id=1a98f45e&"
import script from "./NostoNotFound.vue?vue&type=script&lang=ts&"
export * from "./NostoNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports